var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-12" },
    [
      _vm._m(0),
      _c(
        "div",
        {
          staticClass:
            "flex flex-col lg:flex-row justify-between my-8 mx-4 lg:mx-24 text-[20px]",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "other-container flex flex-col justify-center items-center py-3 lg:py-6 rounded-[12px] lg:rounded-[30px]",
            },
            [
              _c("a-icon", {
                staticClass: "bg-[#f3f4f7] px-4 py-3 rounded-xl",
                attrs: { type: "team" },
              }),
              _c(
                "p",
                {
                  staticClass:
                    "mt-4 lg:mt-8 text-sm lg:text-base font-semibold",
                },
                [_vm._v("我们的团队")]
              ),
              _c("p", { staticClass: "mt-2 text-sm px-6" }, [
                _vm._v(
                  "拥有头部互联网+工业软件+工厂管理背景，来自国内外一流高校"
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "other-container flex flex-col justify-center items-center lg:ml-40 mt-4 lg:mt-0 py-3 lg:py-6 rounded-[12px] lg:rounded-[30px]",
            },
            [
              _c("a-icon", {
                staticClass: "bg-[#f3f4f7] px-4 py-3 rounded-xl",
                attrs: { type: "laptop" },
              }),
              _c(
                "p",
                {
                  staticClass:
                    "mt-4 lg:mt-8 text-sm lg:text-base font-semibold",
                },
                [_vm._v("办公地点")]
              ),
              _c("p", { staticClass: "mt-2 text-sm" }, [
                _vm._v(
                  "四川省成都市龙泉驿区车城西二路菁蓉数字经济产业园2栋1F-111号"
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._m(1),
      _c("home-page-to-contact"),
      _c("home-page-contact"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mx-4 lg:mx-24 pb-16 pt-20 lg:pt-32" }, [
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "text-left mr-4" }, [
          _c(
            "h1",
            {
              staticClass:
                "font-display text-xl lg:text-3xl font-semibold tracking-tight text-slate-900 sm:text-7xl",
            },
            [
              _vm._v(
                " 数据驱动制造，助力中小型非标机械厂数智化、精益化转型升级 "
              ),
            ]
          ),
          _c(
            "p",
            {
              staticClass:
                "mx-auto mt-12 max-w-6xl tracking-tight text-slate-700 text-sm lg:text-lg leading-loose lg:leading-loose",
            },
            [
              _vm._v(
                " 成都轻熵科技有限责任公司，是家专注于为中小非标机械厂提供 ERP & MES 一体化管理系统解决方案（支持非标定制）的服务商。 "
              ),
            ]
          ),
          _c(
            "p",
            {
              staticClass:
                "mx-auto mt-12 max-w-6xl tracking-tight text-slate-700 text-sm lg:text-lg leading-loose lg:leading-loose",
            },
            [
              _vm._v(
                " “轻熵”这一名称蕴含着我们不懈追求的理念一一通过数字化技术为中小非标机械厂创造有序、高效的生产环境。 "
              ),
            ]
          ),
          _c(
            "p",
            {
              staticClass:
                "mx-auto mt-12 max-w-6xl tracking-tight text-slate-700 text-sm lg:text-lg leading-loose lg:leading-loose",
            },
            [
              _vm._v(
                " 我们深知，中小非标机械厂的生产管理面临着多重挑战，尤其是在生产进度不透明、在制品易堆积、产品生产周期长、订单交期不准时等方面。我们的解决方案通过数字化、智能化、精益化的方式，帮助工厂高效管理产品从下单生产到出货对账全流程。通过将业务流程数字化、透明化，减少各环节非增值时间浪费，助力工厂实现更低成本的快速交货。 "
              ),
            ]
          ),
        ]),
        _c("img", {
          staticClass: "rounded-[12px] hidden lg:block",
          attrs: { width: "45%", src: require("@/assets/imgs/bg1.jpg") },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "flex flex-col lg:flex-row justify-between mx-4 lg:mx-24 my-8",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "other-container flex flex-col justify-center items-center py-3 lg:py-6 rounded-[12px] lg:rounded-[30px]",
          },
          [
            _c("img", {
              staticClass: "w-[46px] h-[46px]",
              attrs: { src: require("@/assets/imgs/address.png") },
            }),
            _c(
              "p",
              {
                staticClass: "mt-4 lg:mt-8 text-sm lg:text-base font-semibold",
              },
              [_vm._v("联系地址")]
            ),
            _c("p", { staticClass: "mt-2 text-sm" }, [
              _vm._v(
                "四川省成都市龙泉驿区车城西二路菁蓉数字经济产业园2栋1F-111号"
              ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "other-container flex flex-col justify-center items-center lg:ml-40 mt-4 lg:mt-0 py-3 lg:py-6 rounded-[12px] lg:rounded-[30px]",
          },
          [
            _c("img", {
              staticClass: "w-[46px] h-[46px]",
              attrs: { src: require("@/assets/imgs/email.png") },
            }),
            _c(
              "p",
              {
                staticClass: "mt-4 lg:mt-8 text-sm lg:text-base font-semibold",
              },
              [_vm._v("联系我们")]
            ),
            _c("p", { staticClass: "mt-2 text-sm" }, [
              _vm._v("联系电话：白先生 13364061501（微信同号）"),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }